/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { rewardNodeProvidersGetApiV3TimeseriesRewardNodeProviders } from "../../funcs/rewardNodeProvidersGetApiV3TimeseriesRewardNodeProviders.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3TimeseriesRewardNodeProvidersRequest$inboundSchema
    .optional(),
};

export const tool$rewardNodeProvidersGetApiV3TimeseriesRewardNodeProviders:
  ToolDefinition<typeof args> = {
    name: "get-api-v3-timeseries-reward-node-providers",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await rewardNodeProvidersGetApiV3TimeseriesRewardNodeProviders(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
